module.exports = __webpack_public_path__ + "favicon.ico";


/*****************
 ** WEBPACK FOOTER
 ** ./src/favicon.ico
 ** module id = 1082
 ** module chunks = 0
 **/